export const config_settings = {
  //ecommerce credentials
  //AUTH_SERVER_URL : 'http://localhost:8084',
  //AUTH_SERVER_URL : 'http://35.91.210.157:8084',
  //AUTH_SERVER_URL : 'http://eiff-client-auth-lb-1383061954.us-west-2.elb.amazonaws.com:8084',
  //RESOURCE_SERVER_URL: 'http://localhost:8083/store/1',
  //RESOURCE_SERVER_URL : 'http://35.91.210.157:8083/store/1',
  //AUTH_SERVER_URL: 'https://8u6o8x7jgj.execute-api.us-west-2.amazonaws.com/v1/client-auth',
  //RESOURCE_SERVER_URL: 'https://8u6o8x7jgj.execute-api.us-west-2.amazonaws.com/v1/client-resource/store/1',
  //PHOTO_SERVER_URL: 'https://8u6o8x7jgj.execute-api.us-west-2.amazonaws.com/v1/photo-server',
  //PHOTO_SERVER_URL: 'https://ctppxztfz8.execute-api.us-west-2.amazonaws.com/v1/photo-server',

  AUTH_SERVER_URL:'https://ctppxztfz8.execute-api.us-west-2.amazonaws.com/v2/new-version/client-auth',
  RESOURCE_SERVER_URL:'https://ctppxztfz8.execute-api.us-west-2.amazonaws.com/v2/new-version/client-resource/store/1',
  PHOTO_SERVER_URL: 'https://ctppxztfz8.execute-api.us-west-2.amazonaws.com/v1/photo-server',
  OTHER_SERVICES_RESOURCE_SERVER_URL: 'https://armasperu.com.pe/armaq-php/public',
  WEB_RESOURCE_SERVER_URL: 'http://localhost:8083/store/1',
  DOUBLE_LANGUAGE: false,
  STORE: 1,
  PROD_ENV: true,
};
